import { Endpoint } from "@rest-hooks/endpoint";
export const ChangeContractSettingsEndpoint = new Endpoint(() => fetch("/changeCustomer/settings").then(r => r.json()), {
    dataExpiryLength: 60 * 60 * 1000
});
//# sourceMappingURL=ChangeContractSettings.js.map